import { EvaluationDetailApi } from 'evaluations/interfaces/evaluation';
import { Template } from '../interfaces/templates';

const evaluationTemplateMock: Template = {
  id: 'template-1',
  client_id: 'client-1',
  name: 'Section Refactor Test Template',
  description: 'A mock template for testing',
  sections: [
    {
      id: 'section-1',
      description: 'Soy una descripcion',
      name: 'Normal 1',
      index: 0,
      is_competency: false,
      is_objective: false,
      questions: [
        {
          id: '7cad97d1-6f1e-4429-ad60-e40501d0ab28',
          question: 'La pregunta A',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: true,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '0',
          answers: [
            {
              id: 'c70e0065-7880-47fc-b86c-87d08035fada',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '03d8a694-a185-48c7-9bd1-910c43da597b',
              answer: 'Dos',
              index: '1',
            },
            {
              id: 'a5c02b73-4ad4-42d1-9c99-ac81ab77dd42',
              answer: 'Tres',
              index: '2',
            },
            {
              id: '9afd4069-2959-402a-8009-4272150b6cd5',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
        {
          id: '2726f967-e6c6-4dba-8997-853a7d21b1af',
          question: 'La pregunta B',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: false,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '1',
          answers: [
            {
              id: '55dda6d5-7c37-4ba7-aab3-12cdfd785e29',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '4e1bcb3b-ee63-4dae-9207-3facba847388',
              answer: 'Dos',
              index: '1',
            },
            {
              id: '3dd59664-c605-4f18-92bd-49dfd79f5e2f',
              answer: 'Tres',
              index: '2',
            },
            {
              id: 'c6b95cbb-d072-4c8a-aedb-68625a94b940',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
        {
          id: '91287999-e867-48eb-be60-096925d9ea9c',
          question: 'La pregunta C',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: true,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '2',
          answers: [
            {
              id: 'a0535b80-0997-4255-9c4a-51998161361b',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '9ec14656-d4d9-4c59-99f0-c574d42a1228',
              answer: 'Dos',
              index: '1',
            },
            {
              id: 'ef76b129-c3a1-40f3-8ea2-9357bf3b3df7',
              answer: 'Tres',
              index: '2',
            },
            {
              id: 'bd865c27-4640-4eb3-8405-86caf44236bc',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
        {
          id: '9bdd63c1-45e1-47dd-85ab-cee19c836ce2',
          question: 'La pregunta D',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: false,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '3',
          answers: [
            {
              id: '5a5c9f28-d56d-42d6-a49a-4bbd03eb1430',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '86b6de44-c778-4dba-91b6-47a70893d5d3',
              answer: 'Dos',
              index: '1',
            },
            {
              id: 'fcaa1505-c352-48a4-b8e3-0397279dcf45',
              answer: 'Tres',
              index: '2',
            },
            {
              id: '1419b06b-7ff4-4850-898e-3716fd4c28ce',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
      ],
      use_route_competencies: false,
    },
    {
      id: 'section-2',
      description: null,
      name: 'Competencias 1',
      index: 1,
      is_competency: true,
      is_objective: false,
      questions: [],
      use_route_competencies: false,
      competenciesData: {
        competencies: [
          {
            id: '849f3161-4396-47de-811d-5765a63b323d',
            name: 'Transformación Digital',
            description:
              'A debt splits a symbolic student throughout any phrase. This beneficial innocence peers across a handed scum. The minimum muck scarfs a grade muck.',
            general_evaluation: true,
            levels: [
              {
                id: '1',
                index: 0,
                name: 'Coopera',
                description:
                  'Participa en buen grado con el grupo, apoya sus decisiones. Realiza la parte de trabajo que le corresponde',
              },
              {
                id: '2',
                index: 1,
                name: 'Solicita la opinión al resto del grupo',
                description:
                  'Valora sinceramente las ideas y experiencia de los demás; mantiene una actitud abierta para aprender de los otros, incluso sus pares y reportes directos',
              },
              {
                id: '3',
                index: 2,
                name: 'Anima y motiva a los demás',
                description:
                  'Desarrolla el espíritu de equipo. Actúa para desarrollar un ambiente de trabajo amistoso, buen clima y espíritu de cooperación. Resuelve los conflictos que se puedan producir dentro del equipo',
              },
              {
                id: '4',
                index: 3,
                name: 'Fortalece el espíritu de equipo en la organización',
                description:
                  'Expresa satisfacción personal con los éxitos de sus pares o de otras líneas de negocios. Se preocupa por apoyar el desempeño de otras áreas de la compañía, aunque la organización no le de suficiente apoyo',
              },
            ],
          },
          {
            id: '2',
            name: 'Liderazgo',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. At magna ut mauris, condimentum pharetra, etiam id consequat dictumst.',
            general_evaluation: false,
            levels: [
              {
                id: '1',
                index: 0,
                name: 'Motivador',
                description:
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Risus viverra adipiscing at in tellus integer feugiat scelerisque',
              },
              {
                id: '2',
                index: 1,
                name: 'Orador',
                description:
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
              },
              {
                id: '3',
                index: 3,
                name: 'Lider nato',
                description:
                  'Volutpat sed cras ornare arcu dui vivamus arcu felis bibendum ut tristique et egestas quis ipsum suspendisse ultrices gravida dictum',
              },
            ],
          },
          {
            id: '3',
            name: 'Pensamiento Crítico',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. At magna ut mauris, condimentum pharetra, etiam id consequat dictumst.',
            general_evaluation: false,
            levels: [
              {
                id: '1',
                index: 0,
                name: 'No muy crítico',
                description:
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Risus viverra adipiscing at in tellus integer feugiat scelerisque',
              },
              {
                id: '2',
                index: 1,
                name: 'Aparentemente sabe de lo que habla',
                description:
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
              },
              {
                id: '3',
                index: 2,
                name: 'Crítico de telenovelas',
                description:
                  'Volutpat sed cras ornare arcu dui vivamus arcu felis bibendum ut tristique et egestas quis ipsum suspendisse ultrices gravida dictum',
              },
            ],
          },
        ],
        question: {
          id: '86b0f0c4-33ca-4e1d-be94-a86d1bcb406c',
          question: 'Que tan productivo eres?',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'SCALE',
          scale_type: 'TEXT',
          has_comments: false,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '0',
          answers: [
            {
              id: 'cab1bcfc-d3b4-45f1-9380-a1ad907047ef',
              answer: 'Excelente',
              index: '0',
            },
            {
              id: 'aacacee7-f6be-45f7-a083-3237eea4f08a',
              answer: 'Mucho',
              index: '1',
            },
            {
              id: 'a062adcb-5e1f-4a20-9ca2-45b46682806c',
              answer: 'Normal',
              index: '2',
            },
            {
              id: '5efafb64-6499-437b-9735-41397bcb90ab',
              answer: 'Poco',
              index: '3',
            },
            {
              id: '04fb1c0b-c23a-43b7-a8ce-5be343416293',
              answer: 'Poquisimo',
              index: '4',
            },
          ],
          collapsed: true,
        },
        useRouteCompetencies: false,
      },
    },
    {
      id: 'section-3',
      description: null,
      name: 'Normal 2',
      index: 2,
      is_competency: false,
      is_objective: false,
      questions: [
        {
          id: '7cad97d1-6f1e-4429-ad60-e4050S1d0ab28',
          question: 'La pregunta E',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: true,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '0',
          answers: [
            {
              id: 'c70e0065-7880-d47fc-b86c-87d08035fada',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '03d8a694-a185-d48c7-9bd1-910c43da597b',
              answer: 'Dos',
              index: '1',
            },
            {
              id: 'a5c02b73-4ad4-d42d1-9c99-ac81ab77dd42',
              answer: 'Tres',
              index: '2',
            },
            {
              id: '9afd4069-2959-4d02a-8009-4272150b6cd5',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
        {
          id: '2726f967-ae6c6-4dba-q8997-853a7d21b1af',
          question: 'La pregunta F',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: false,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '1',
          answers: [
            {
              id: '55dda6d5-7c37-4ba7-aab3-12cdfdv785e29',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '4e1bcb3b-ee63-4dae-9207-3facbva847388',
              answer: 'Dos',
              index: '1',
            },
            {
              id: '3dd596v64-c605-4f18-92bd-49dfd79f5e2f',
              answer: 'Tres',
              index: '2',
            },
            {
              id: 'c6b95cbb-d0v72-4c8a-aedb-68625a94b940',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
        {
          id: '91287999-e867-48eb-be60-0969a25d9ea9c',
          question: 'La pregunta G',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: true,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '2',
          answers: [
            {
              id: 'a0535b80-0997-42a55-9c4a-51998161361b',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '9ec14656-d4d9-4ac59-99f0-c574d42a1228',
              answer: 'Dos',
              index: '1',
            },
            {
              id: 'ef76b129-c3a1-4a0f3-8ea2-9357bf3b3df7',
              answer: 'Tres',
              index: '2',
            },
            {
              id: 'bd865c27-4640-4eba3-8405-86caf44236bc',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
        {
          id: '9bdda63c1-45e1-47dd-85aab-cee19c83q6ce2',
          question: 'La pregunta H',
          description: '',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'MULTIPLE_OPTIONS',
          scale_type: 'NUMERIC',
          has_comments: false,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '3',
          answers: [
            {
              id: '5a5c9f28-d56zd-42d6-a4a9a-4bbd03eb1430',
              answer: 'Uno',
              index: '0',
            },
            {
              id: '86b6de44-c778-4zba-91ba6-47a70893d5d3',
              answer: 'Dos',
              index: '1',
            },
            {
              id: 'fcaa1505-c352-48za4-b8e3-03a97279dcf45',
              answer: 'Tres',
              index: '2',
            },
            {
              id: '1419b06b-7ff4-4z50-898e-371a6fd4c28ce',
              answer: 'Cuatro',
              index: '3',
            },
          ],
          collapsed: true,
        },
      ],
      use_route_competencies: false,
    },
    {
      id: 'section-4',
      description: 'Soy una descripcion',
      name: 'Objetivos 1',
      index: 3,
      is_competency: false,
      is_objective: true,
      questions: [],
      use_route_competencies: false,
      objectivesData: {
        objectives: [
          {
            id: 'objective-1',
            name: 'Crear un prototipo de alta fidelidad',
            type: 'RC',
            percent: 65,
            objectiveCycle: 'Q3 2022',
          },
          {
            id: 'objective-2',
            name: 'Construir una experiencia de usuario maravillosa',
            type: 'OBJ',
            percent: 42,
            objectiveCycle: 'Q2 2022',
          },
        ],
        question: {
          id: '989180d4-8e33-44bf-a883-fa7e14f4c550',
          question: 'Mide el desempeño del colaboador en sus resultados clave',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. At magna ut mauris, condimentum pharetra, etiam id consequat dictumst.',
          answers_is_optional: false,
          has_answers: true,
          type_of_answers: 'SCALE',
          scale_type: 'NUMERIC',
          has_comments: true,
          comments_is_optional: false,
          restrict_visibility: false,
          index: '0',
          answers: [
            {
              id: '7919106e-057f-40f0-b1ac-69241531c4d3',
              answer: '1',
              index: '0',
            },
            {
              id: '68027ae7-7366-4fa3-a191-709430721294',
              answer: '2',
              index: '1',
            },
            {
              id: 'b8c70880-b252-4bf7-8124-0044b21c7659',
              answer: '3',
              index: '2',
            },
            {
              id: 'f551cd2f-562b-49e5-8d71-d8eca0ace9e7',
              answer: '4',
              index: '3',
            },
            {
              id: '6a65adfa-680d-47c9-8097-b014f4a1038a',
              answer: '5',
              index: '4',
            },
          ],
          collapsed: true,
        },
      },
    },
  ],
};

export const evaluationMock: EvaluationDetailApi = {
  evaluationId: 'evaluation-1',
  evaluatedId: '09a0b3d2-ddb1-44be-a2b5-f814f7fe5e6a',
  evaluatedImageUrl:
    'https://res.cloudinary.com/lernit/image/upload/v1661536009/Courses/isoj5wsgliqxrb3ap9rj.jpg',
  evaluatedName: 'Franco Rocchia',
  evaluatedOuName: 'Engineering',
  answers: null,
  template: evaluationTemplateMock,
  status: 'not_started',
  progress: 0,
};
